var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.8914 8.47832C22.1606 8.47832 24.0001 6.63879 24.0001 4.36962C24.0001 2.10045 22.1606 0.260925 19.8914 0.260925C17.6222 0.260925 15.7827 2.10045 15.7827 4.36962C15.7827 6.63879 17.6222 8.47832 19.8914 8.47832Z",
    fill: "#D94545"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3337 17.5891C14.8498 15.0264 15.7154 13.6085 15.1321 8.86483C14.6094 4.61467 11.3546 3.39788 9.68751 3.05053V0H7.99126V3.05053C6.32184 3.39788 3.06703 4.61462 2.54557 8.86483C1.96228 13.6063 2.82788 15.0264 1.34396 17.5891C0.949638 18.2655 0.457323 18.8093 0 19.2286V20.218H17.6764V19.2286C17.2203 18.8093 16.7257 18.2655 16.3337 17.5891Z",
    fill: "#626262"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.83818 24.9755C9.98309 24.9755 10.9112 24.0665 10.9112 22.9452C10.9112 21.8239 9.98309 20.915 8.83818 20.915C7.69327 20.915 6.76514 21.8239 6.76514 22.9452C6.76514 24.0665 7.69327 24.9755 8.83818 24.9755Z",
    fill: "#626262"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.755bfc3a6356330df85682f87dff1980.svg";
export { ForwardRef as ReactComponent };